var $c6379d408d0b775b$exports = {};
// Sticky top navigation: disclosure submenus (W3C APG "Disclosure Navigation
// Menu"), mobile hamburger panel with focus trap, Esc/outside-click close, and
// accessible state management.
//
// Submenus are button-driven rather than hover-driven so the same interaction
// works with a mouse, a keyboard and a touch screen, and so the open state has
// exactly one source of truth: aria-expanded. CSS reads it; this file sets it.
const $c6379d408d0b775b$var$toggle = document.getElementById("site-nav-toggle");
const $c6379d408d0b775b$var$panel = document.getElementById("site-nav-panel");
const $c6379d408d0b775b$var$nav = document.querySelector(".site-nav");
if ($c6379d408d0b775b$var$toggle && $c6379d408d0b775b$var$panel && $c6379d408d0b775b$var$nav) {
    const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const submenuToggles = Array.from($c6379d408d0b775b$var$panel.querySelectorAll(".site-nav__submenu-toggle"));
    const isOpen = ()=>$c6379d408d0b775b$var$toggle.getAttribute("aria-expanded") === "true";
    // A closed submenu keeps its links in the DOM (display:none), so the focus
    // trap has to skip them — otherwise Tab lands on items nobody can see.
    // This test only catches elements with no box at all, which is sufficient
    // because display:none is the only hiding technique the nav CSS uses. It
    // would silently fail to filter visibility:hidden, opacity:0 or inert, so
    // keep the two in step if the CSS ever changes.
    const getFocusable = ()=>Array.from($c6379d408d0b775b$var$panel.querySelectorAll(focusableSelector)).filter((el)=>el.getClientRects().length > 0);
    const openSubmenu = ()=>submenuToggles.find((button)=>button.getAttribute("aria-expanded") === "true");
    const closeSubmenus = ()=>{
        submenuToggles.forEach((button)=>button.setAttribute("aria-expanded", "false"));
    };
    // The panel is absolutely positioned under a *sticky* header, so the space
    // below it depends on where that header currently sits: flush at the top of
    // the viewport once the page is scrolled, but lower than that at scroll 0.
    // A viewport-relative max-height in CSS therefore overshoots and pushes the
    // last item off-screen. Measure instead of assume.
    const sizePanel = ()=>{
        const navBottom = $c6379d408d0b775b$var$nav.getBoundingClientRect().bottom;
        const available = window.innerHeight - navBottom;
        $c6379d408d0b775b$var$panel.style.maxHeight = `${Math.max(160, Math.floor(available))}px`;
    };
    const openPanel = ()=>{
        $c6379d408d0b775b$var$toggle.setAttribute("aria-expanded", "true");
        $c6379d408d0b775b$var$nav.classList.add("site-nav--open");
        sizePanel();
        const first = getFocusable()[0];
        if (first) first.focus();
    };
    const closePanel = (returnFocus = true)=>{
        $c6379d408d0b775b$var$toggle.setAttribute("aria-expanded", "false");
        $c6379d408d0b775b$var$nav.classList.remove("site-nav--open");
        closeSubmenus();
        $c6379d408d0b775b$var$panel.style.removeProperty("max-height");
        if (returnFocus) $c6379d408d0b775b$var$toggle.focus();
    };
    window.addEventListener("resize", ()=>{
        if (isOpen()) sizePanel();
    });
    // Must track the hamburger breakpoint in index.css. Crossing it while the
    // panel is open otherwise leaves aria-expanded="true" on a display:none
    // button — which both lies to assistive tech and makes the Tab trap below
    // unescapable, because its forward branch focuses a button that is no longer
    // rendered.
    const handheld = window.matchMedia("(max-width: 849px)");
    handheld.addEventListener("change", (event)=>{
        if (!event.matches && isOpen()) closePanel(false);
    });
    $c6379d408d0b775b$var$toggle.addEventListener("click", ()=>{
        if (isOpen()) closePanel();
        else openPanel();
    });
    // Only one submenu open at a time; the click must not reach the
    // outside-click handler below.
    submenuToggles.forEach((button)=>{
        button.addEventListener("click", (event)=>{
            event.stopPropagation();
            const wasOpen = button.getAttribute("aria-expanded") === "true";
            closeSubmenus();
            if (!wasOpen) button.setAttribute("aria-expanded", "true");
        });
    });
    // Navigating via a panel link closes the menu (no focus return — let target
    // receive it). Closing happens after the click is dispatched, so the
    // navigation itself is unaffected.
    $c6379d408d0b775b$var$panel.querySelectorAll("a").forEach((link)=>{
        link.addEventListener("click", ()=>{
            closeSubmenus();
            if (isOpen()) closePanel(false);
        });
    });
    document.addEventListener("keydown", (event)=>{
        // Esc unwinds one level at a time: submenu first, then the mobile panel.
        if (event.key === "Escape") {
            const expanded = openSubmenu();
            if (expanded) {
                expanded.setAttribute("aria-expanded", "false");
                expanded.focus();
                return;
            }
            if (isOpen()) closePanel();
            return;
        }
        if (!isOpen()) return;
        if (event.key === "Tab") {
            // Belt and braces alongside the breakpoint listener: never trap focus
            // against a hamburger that is not rendered.
            if ($c6379d408d0b775b$var$toggle.getClientRects().length === 0) return;
            const focusable = getFocusable();
            if (focusable.length === 0) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;
            if (!first || !last) return;
            // Keep focus within toggle + panel while the menu is open.
            if (event.shiftKey) {
                if (active === first || active === $c6379d408d0b775b$var$toggle) {
                    event.preventDefault();
                    last.focus();
                }
            } else if (active === last) {
                event.preventDefault();
                $c6379d408d0b775b$var$toggle.focus();
            }
        }
    });
    // Tabbing out of the nav closes the submenu too, per the APG pattern —
    // otherwise a dropdown can stay open over content the user has moved focus
    // into. Checking relatedTarget keeps a click on a submenu link safe: focus
    // moves within the nav, so nothing is hidden between mousedown and click.
    $c6379d408d0b775b$var$nav.addEventListener("focusout", (event)=>{
        const next = event.relatedTarget;
        if (next instanceof Node && $c6379d408d0b775b$var$nav.contains(next)) return;
        closeSubmenus();
    });
    // Click outside the nav closes whatever is open.
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if ($c6379d408d0b775b$var$nav.contains(target)) return;
        closeSubmenus();
        if (isOpen()) closePanel(false);
    });
}


//# sourceMappingURL=agentic-tv-operations.f3e164e3.js.map
